"use client"

import { useState, useEffect } from "react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { PortfolioContent } from "./portfolio-content"
import type { PortfolioData } from "@/lib/api-service"

interface PortfolioTabsProps {
  portfolios: PortfolioData[]
}

export function PortfolioTabs({ portfolios }: PortfolioTabsProps) {
  const [activePortfolio, setActivePortfolio] = useState<string>("")

  // Set the first portfolio as active when portfolios change
  useEffect(() => {
    if (portfolios && portfolios.length > 0) {
      setActivePortfolio(portfolios[0].id.toString())
    }
  }, [portfolios])

  if (!portfolios || portfolios.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-muted-foreground">No portfolio data available</p>
      </div>
    )
  }

  const gridCols = portfolios.length === 1 ? "grid-cols-1" : 
                   portfolios.length === 2 ? "grid-cols-2" : "grid-cols-3"

  return (
    <Tabs value={activePortfolio} onValueChange={setActivePortfolio}>
      <TabsList className={`grid w-full ${gridCols} h-auto`}>
        {portfolios.map((portfolio) => (
          <TabsTrigger 
            key={portfolio.id} 
            value={portfolio.id.toString()} 
            className="px-1 py-1 text-xs relative group"
            title={portfolio.description}
          >
            <div className="text-center truncate">
              <div className="font-medium">{portfolio.name}</div>
            </div>
          </TabsTrigger>
        ))}
      </TabsList>

      {portfolios.map((portfolio) => (
        <TabsContent key={portfolio.id} value={portfolio.id.toString()} className="space-y-4">
          <PortfolioContent portfolio={portfolio} />
        </TabsContent>
      ))}
    </Tabs>
  )
}
